/* Contains the default layouts structure for each page */

import { v4 as uuid4 } from "uuid"
import store from "@/store"

const getPageDefaultLayout = (forecasting_id) => {
  const current_forecast = store.state.data.user_forecasts.find((f) => f.id == forecasting_id)
  let name = current_forecast.name
  let slug = forecasting_id
  const layout = [
    {
      h: 7,
      w: 20,
      x: 0,
      y: 0,
      id: uuid4(),
      maxH: 72,
      minH: 6,
      minW: 6,
      name: "ARR",
      moved: false,
      props: {
        hidden: false,
        component_type: "forecasting_metric",
        component_props: {
          label: "ARR",
          dataSource: "default_forecast_table",
          metricName: "arr"
        },
        component_reference: "forecasting>default_forecast_tablet>1"
      },
      metricName: "arr",
      data_source: "default_forecast_table",
      preserveAspectRatio: false
    },
    {
      h: 7,
      w: 20,
      x: 20,
      y: 0,
      id: uuid4(),
      maxH: 72,
      minH: 6,
      minW: 6,
      name: "MRR",
      moved: false,
      props: {
        hidden: false,
        component_type: "forecasting_metric",
        component_props: {
          label: "MRR",
          dataSource: "default_forecast_table",
          metricName: "mrr"
        },
        component_reference: "forecasting>default_forecast_tablet>2"
      },
      metricName: "mrr",
      data_source: "default_forecast_table",
      preserveAspectRatio: false
    },
    {
      h: 7,
      w: 32,
      x: 40,
      y: 0,
      id: uuid4(),
      maxH: 72,
      minH: 6,
      minW: 6,
      name: "# of Accounts",
      moved: false,
      props: {
        hidden: false,
        component_type: "forecasting_metric",
        component_props: {
          label: "# of Accounts",
          dataSource: "default_forecast_table",
          metricName: "forecast_summary"
        },
        component_reference: "forecasting>default_forecast_tablet>3"
      },
      metricName: "forecast_summary",
      data_source: "default_forecast_table",
      preserveAspectRatio: false
    },
    {
      h: 21,
      w: 48,
      x: 0,
      y: 7,
      id: uuid4(),
      maxH: 72,
      minH: 6,
      minW: 12,
      name: "Forecast status",
      moved: false,
      props: {
        hidden: false,
        component_type: "forecasting_metric",
        component_props: {
          label: "Forecast status",
          dataSource: "default_forecast_table",
          metricName: "forecast_status"
        },
        component_reference: "forecasting>default_forecast_tablet>4"
      },
      metricName: "forecast_status",
      data_source: "default_forecast_table",
      preserveAspectRatio: false
    },
    {
      h: 7,
      w: 24,
      x: 48,
      y: 7,
      id: uuid4(),
      maxH: 72,
      minH: 6,
      minW: 12,
      name: "Gap to GRR",
      moved: false,
      props: {
        hidden: false,
        component_type: "forecasting_metric",
        component_props: {
          label: "Gap to GRR",
          dataSource: "default_forecast_table",
          metricName: "gap_to_grr"
        },
        component_reference: "forecasting>default_forecast_tablet>5"
      },
      metricName: "gap_to_grr",
      data_source: "default_forecast_table",
      preserveAspectRatio: false
    },
    {
      h: 7,
      w: 24,
      x: 48,
      y: 14,
      id: uuid4(),
      maxH: 72,
      minH: 6,
      minW: 12,
      name: "Gap to NRR",
      moved: false,
      props: {
        hidden: false,
        component_type: "forecasting_metric",
        component_props: {
          label: "Gap to NRR",
          dataSource: "default_forecast_table",
          metricName: "gap_to_nrr"
        },
        component_reference: "forecasting>default_forecast_tablet>6"
      },
      metricName: "gap_to_nrr",
      data_source: "default_forecast_table",
      preserveAspectRatio: false
    },
    {
      h: 7,
      w: 24,
      x: 48,
      y: 21,
      id: uuid4(),
      maxH: 72,
      minH: 6,
      minW: 12,
      name: "Gap to Bookings",
      moved: false,
      props: {
        hidden: false,
        component_type: "forecasting_metric",
        component_props: {
          label: "Gap to Bookings",
          dataSource: "default_forecast_table",
          metricName: "gap_to_bookings"
        },
        component_reference: "forecasting>default_forecast_tablet>7"
      },
      metricName: "gap_to_bookings",
      data_source: "default_forecast_table",
      preserveAspectRatio: false
    },
    {
      h: 36,
      w: 72,
      x: 0,
      y: 28,
      minW: 24,
      minH: 24,
      is_static: true,
      fixed: true,
      id: uuid4(),
      props: {
        component_type: "forecast_table",
        component_reference: "default_forecast_table",
        component_props: {
          label: "Forecast Table",
          objectType: current_forecast.type,
          view_by: null,
          forecast_name: current_forecast.id
        }
      }
    }
  ]

  return [layout, name, slug]
}

export default getPageDefaultLayout
